/* eslint-disable @typescript-eslint/unbound-method */
import { createContext, useContext } from "react";
import { DriveStore } from "../../../store/reducers";

export class StoreContextType {
    constructor (private readonly driveStore: DriveStore) {}

    get store() {
        return this.driveStore;
    }
}

export const StoreContext = createContext<StoreContextType | undefined>(undefined);

export const useStoreContext = (): StoreContextType => {
    const context = useContext(StoreContext);
    if (!context) {
        throw new Error("useContext returned an undefined context for the StoreContext");
    }
    return context;
};